import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {Component} from "react";
import * as React from "react";
import {Button, CardBody} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";
import './RozpracovanaObjednavkaModal.scss';

/**
 * Modální dialog umožňující uživateli zvolit si mezi pokračováním v rozpracované objednávce nebo vytvořením nové objednávky.
 */
class RozpracovanaObjednavkaModal extends Component<WithTranslation> {

    static propTypes = {
        onContinueOrder: PropTypes.func.isRequired, // funkce volaná při volbě "Pokračovat"
        onNewOrder: PropTypes.func.isRequired, // funkce volaná při volbě "Nová objednávka"
    };

    render() {
        const {onContinueOrder, onNewOrder, t} = this.props;
        return <CardBody className={"rozpracovana-objednavka-modal"}>
            <p>{t('order.unfinished_order_prompt')}</p>
            <div className={"buttons"}>
                <Button color="primary" onClick={onContinueOrder}>{t('continue')}</Button>
                <Button color="secondary" onClick={onNewOrder}>{t('order.new')}</Button>
            </div>
        </CardBody>
    }
}

export default connect()(withTranslation()(RozpracovanaObjednavkaModal));
